export const FETCH_APPROVAL_REQUESTS_PENDING = 'FETCH_APPROVAL_REQUESTS_PENDING'
export const FETCH_APPROVAL_REQUESTS_FULFILLED = 'FETCH_APPROVAL_REQUESTS_FULFILLED'
export const FETCH_APPROVAL_REQUESTS_REJECTED = 'FETCH_APPROVAL_REQUESTS_REJECTED'

export const FETCH_APPROVAL_REQUEST_DETAIL_PENDING = 'FETCH_APPROVAL_REQUEST_DETAIL_PENDING'
export const FETCH_APPROVAL_REQUEST_DETAIL_FULFILLED = 'FETCH_APPROVAL_REQUEST_DETAIL_FULFILLED'
export const FETCH_APPROVAL_REQUEST_DETAIL_REJECTED = 'FETCH_APPROVAL_REQUEST_DETAIL_REJECTED'

export const UPDATE_SELECTED_APPROVAL_REQUEST = 'UPDATE_SELECTED_APPROVAL_REQUEST'
export const CLEAR_SELECTED_APPROVAL_REQUEST = 'CLEAR_SELECTED_APPROVAL_REQUEST'

export const START_PROCESSING_APPROVAL_REQUEST = 'START_PROCESSING_APPROVAL_REQUEST'
export const STOP_PROCESSING_APPROVAL_REQUEST = 'STOP_PROCESSING_APPROVAL_REQUEST'

export const SUBMIT_APPROVAL_REQUEST_PENDING = 'SUBMIT_APPROVAL_REQUEST_PENDING'
export const SUBMIT_APPROVAL_REQUEST_FULFILLED = 'SUBMIT_APPROVAL_REQUEST_FULFILLED'
export const SUBMIT_APPROVAL_REQUEST_REJECTED = 'SUBMIT_APPROVAL_REQUEST_REJECTED'
export const RESET_APPROVAL_REQUEST = 'RESET_APPROVAL_REQUEST'

export const SET_APPROVAL_REQUEST_TABLE_SORT_COLUMN = 'SET_APPROVAL_REQUEST_TABLE_SORT_COLUMN'
export const SET_APPROVAL_REQUEST_TABLE_SORT_DIR = 'SET_APPROVAL_REQUEST_TABLE_SORT_DIR'
export const SET_APPROVAL_REQUEST_TABLE_SORT_COLUMN_AND_DIR =
  'SET_APPROVAL_REQUEST_TABLE_SORT_COLUMN_AND_DIR'

export const PROCESS_REQUEST_FORM = 'processRequestForm'
export const PROCESS_REQUEST_STATUS_FIELD = 'processRequestStatus'
export const PROCESS_REQUEST_COMMENTS_FIELD = 'processRequestComments'
export const PROCESS_REQUEST_HAND_SHIPMENT_FIELD = 'etsHandshipmentFlag'

export const STATUS_NEW = 'APPROVAL_PENDING'
export const STATUS_APPROVED = 'APPROVED'
export const STATUS_DENIED = 'REJECTED'
export const STATUS_NEEDS_INFO = 'REQUIRES_INFO'
export const STATUS_SUBMITTED = 'SUBMITTED'
export const STATUS_CANCELLED = 'CANCELLED_SUBMITTED'
export const STATUS_UPDATED = 'UPDATED'
export const ETS_STATUS = {
  [STATUS_NEW]: 'New',
  [STATUS_APPROVED]: 'Approved',
  [STATUS_DENIED]: 'Denied',
  [STATUS_NEEDS_INFO]: 'Needs Info',
  [STATUS_SUBMITTED]: 'Submitted',
  [STATUS_UPDATED]: 'Updated',
  [STATUS_CANCELLED]: 'Cancelled',
}
export const APPROVAL_STATUS_LABEL = {
  [STATUS_NEW]: 'new',
  [STATUS_APPROVED]: 'approved',
  [STATUS_NEEDS_INFO]: 'needs-info',
  [STATUS_DENIED]: 'denied',
}
export const ETS_STATUS_SORT_ORDER = {
  [STATUS_NEW]: 1,
  [STATUS_APPROVED]: 2,
  [STATUS_DENIED]: 4,
  [STATUS_NEEDS_INFO]: 3,
}
export const DISPLAY_STATUS = {
  [STATUS_NEW]: 'Submitted',
  [STATUS_APPROVED]: 'Approved',
  [STATUS_DENIED]: 'Denied',
  [STATUS_NEEDS_INFO]: 'Needs Info',
  [STATUS_SUBMITTED]: 'Submitted',
  [STATUS_UPDATED]: 'Updated',
  [STATUS_CANCELLED]: 'Cancelled',
}

export const PROCESS_REQUEST_STATUS_OPTIONS = [
  { label: 'Approved', value: STATUS_APPROVED },
  { label: 'Needs Info', value: STATUS_NEEDS_INFO },
  { label: 'Denied', value: STATUS_DENIED },
]

export const ARTYPE_OFFCYCLETESTING = 'offCycleTesting'
export const ARTYPE_NONSTOCKEDSSD = 'nonStockedSSD'
export const ARTYPE_ANCILLARYMATERIALS = 'ancillaryMaterials'
export const ARTYPE_SECURE_ANCILLARYMATERIALS = 'secureAncillaryMaterials'
export const ARTYPE_NON_SECURE_ANCILLARYMATERIALS = 'nonSecureAncillaryMaterials'
export const ARTYPE_EXCEPTIONTESTING = 'exceptionTesting'
export const ARTYPE_ORDERSAFTERDEADLINE = 'ordersAfterDeadline'
export const ARTYPE_RESHIPMENTS = 'reshipments'

export const APPROVAL_REQUEST_CONFIG = {
  [ARTYPE_NONSTOCKEDSSD]: {
    requestsEndpoint:
      '/v2/orders/education-periods/{educationPeriodCd}/nonstocked-ets-approval-requests',
    detailsEndpoint: '/v2/orders/special-order/{id}/nonstocked-approval-request-details',
    approvedEndpoint: '/v2/orders/nonstocked-ets-approval',
    needsInfoEndpoint: '/v2/orders/nonstocked-ets-needinfo',
    deniedEndpoint: '/v2/orders/nonstocked-ets-denial',
    idField: 'specialOrderId',
    processAdditionalFields: [],
  },
  [ARTYPE_ANCILLARYMATERIALS]: {
    requestsEndpoint:
      '/orders/education-periods/{educationPeriodCd}/ancillary-materials-ets-approval-requests',
    detailsEndpoint: {},
    approvedEndpoint: {},
    needsInfoEndpoint: {},
    deniedEndpoint: {},
    idField: 'specialOrderId',
    processAdditionalFields: ['apOrderId'],
  },
  [ARTYPE_SECURE_ANCILLARYMATERIALS]: {
    requestsEndpoint:
      '/orders/education-periods/{educationPeriodCd}/ancillary-materials-ets-approval-requests',
    detailsEndpoint:
      '/orders/special-order/{id}/secure-ancillary-materials-approval-request-details',
    approvedEndpoint: '/orders/secure-materials-ets-approval',
    needsInfoEndpoint: '/orders/secure-materials-ets-needinfo',
    deniedEndpoint: '/orders/secure-materials-ets-deny',
    idField: 'specialOrderId',
    processAdditionalFields: ['apOrderId'],
  },
  [ARTYPE_NON_SECURE_ANCILLARYMATERIALS]: {
    requestsEndpoint:
      '/orders/education-periods/{educationPeriodCd}/ancillary-materials-ets-approval-requests',
    detailsEndpoint:
      '/orders/special-order/{id}/non-secure-ancillary-materials-approval-request-details',
    approvedEndpoint: '/orders/non-secure-materials-ets-approval',
    needsInfoEndpoint: '/orders/non-secure-materials-ets-needinfo',
    deniedEndpoint: '/orders/non-secure-materials-ets-denial',
    idField: 'specialOrderId',
    processAdditionalFields: ['apOrderId'],
  },
  [ARTYPE_EXCEPTIONTESTING]: {
    requestsEndpoint:
      '/orders/education-periods/{educationPeriodCd}/exception-test-ets-approval-requests',
    detailsEndpoint: '/orders/special-order/{id}/exception-tests-approval-request-details',
    approvedEndpoint: '/orders/exception-tests-ets-approval',
    needsInfoEndpoint: '/orders/exception-tests-ets-needinfo',
    deniedEndpoint: '/orders/exception-tests-ets-denial',
    idField: 'specialOrderId',
    processAdditionalFields: ['apOrderId'],
  },
  [ARTYPE_OFFCYCLETESTING]: {
    requestsEndpoint: '/orders/education-periods/{educationPeriodCd}/approval-requests/off-cycle',
    detailsEndpoint: '/orders/approval-requests/off-cycle/{id}',
    approvedEndpoint: '/orders/off-cycle-approval',
    needsInfoEndpoint: '/orders/off-cycle-need-info',
    deniedEndpoint: '/orders/off-cycle-denial',
    idField: 'specialOrderId',
    processAdditionalFields: ['apOrderId'],
  },
  [ARTYPE_ORDERSAFTERDEADLINE]: {
    requestsEndpoint:
      '/orders/education-periods/{educationPeriodCd}/orders-after-deadline-approval-requests',
    detailsEndpoint: '/orders/special-order/{id}/orders-after-deadline-approval-request-details',
    approvedEndpoint: '/orders/orders-after-deadline-ets-approval',
    needsInfoEndpoint: '/orders/orders-after-deadline-ets-needinfo',
    deniedEndpoint: '/orders/orders-after-deadline-ets-denial',
    idField: 'specialOrderId',
    processAdditionalFields: ['apOrderId'],
  },
  [ARTYPE_RESHIPMENTS]: {
    requestsEndpoint: '/orders/education-periods/{educationPeriodCd}/reshipment/approval-requests',
    detailsEndpoint: '/orders/special-order/{id}/reshipment/approval-request-details',
    approvedEndpoint: '/orders/reshipment-materials-ets-approval',
    needsInfoEndpoint: '/orders/reshipment-materials-ets-needinfo',
    deniedEndpoint: '/orders/reshipment-materials-ets-denial',
    idField: 'specialOrderId',
    processAdditionalFields: ['apOrderId'],
  },
}

export const SPECIAL_ORDER_TYPE_SECURE = 'SECURE_ANCILLARY'
export const SPECIAL_ORDER_TYPE_NON_SECURE = 'NON_SECURE_ANCILLARY'

export const HANDSHIPMENT_ALLOWED = [
  ARTYPE_SECURE_ANCILLARYMATERIALS,
  ARTYPE_NON_SECURE_ANCILLARYMATERIALS,
  ARTYPE_EXCEPTIONTESTING,
  ARTYPE_ORDERSAFTERDEADLINE,
  ARTYPE_RESHIPMENTS,
]

export const STATUS_STYLE_MAP = {
  [STATUS_SUBMITTED]: { fontWeight: 'bold' },
  [STATUS_UPDATED]: { fontWeight: 'bold' },
  [STATUS_CANCELLED]: { fontWeight: 'bold' },
  [STATUS_APPROVED]: { fontWeight: 'bold' },
  [STATUS_NEEDS_INFO]: { fontWeight: 'bold' },
  [STATUS_DENIED]: { fontWeight: 'bold' },
  [STATUS_NEW]: { fontWeight: 'bold' },
}

export const AR_ID = 'id'
export const AR_AICODE = 'aiCode'
export const AR_STATUS = 'status'
export const AR_EXAMDATE = 'examDate'

export const EXCEPTION_TEST_ADMIN = 'EXCEPTION'

export const FETCH_APPROVAL_REQUEST_EXAM_WINDOWS = 'FETCH_APPROVAL_REQUEST_EXAM_WINDOWS'

export const SET_APPROVAL_REQUESTS_SELECTED_EDUCATION_PERIOD =
  'SET_APPROVAL_REQUESTS_SELECTED_EDUCATION_PERIOD'
